import { ShareLinkWrapper } from './wrapper'

import { Skeleton, Stack } from 'design-system'

export const ShareLinkLoading = () => {
  return (
    <ShareLinkWrapper>
      <Stack gap={4}>
        <div className="mb-2 flex justify-center">
          <Skeleton className="h-10 w-10 rounded-full" />
        </div>
        <Stack gap={3}>
          <Skeleton className="h-4" />
          <Skeleton className="h-4" />
        </Stack>
        <div className="flex justify-center">
          <Skeleton className="h-4 w-96" />
        </div>
      </Stack>
    </ShareLinkWrapper>
  )
}
